(() => {
  'use strict';

  const MTO_ORDER_CLASS = 'mto';
  const MTO_ORDER_CLASS_PROPERTY = '_kuden_order_class';
  const MTO_ORDER_CLASS_INPUT = `properties[${MTO_ORDER_CLASS_PROPERTY}]`;
  const CART_JSON_FALLBACK = '/cart.js';
  const CART_CHECK_TIMEOUT_MS = 10000;
  const MIXED_CART_MESSAGE = '販売・配送条件が異なるため、KUDEN 01の受注生産品とその他の商品は別々にご注文ください。';
  const CART_CHECK_ERROR_MESSAGE = 'カートの状態を確認できませんでした。通信環境を確認して、もう一度お試しください。';
  const MTO_PRODUCT_PAGE_MESSAGE = 'KUDEN 01の受注生産品は、商品ページで仮サイズと確認事項を入力してからカートへ追加してください。';

  function getCartJsonUrl() {
    const localizedRoot = window.Shopify?.routes?.root;
    return localizedRoot ? `${localizedRoot}cart.js` : CART_JSON_FALLBACK;
  }

  function getIncomingOrderClass(form) {
    // The MTO fields sit outside the <form> and are bound to it by the form
    // attribute, so querySelector cannot reach them. form.elements can.
    const field = form.elements?.namedItem(MTO_ORDER_CLASS_INPUT);
    const value = field?.value ?? form.querySelector(`[name="${MTO_ORDER_CLASS_INPUT}"]`)?.value;
    return value === MTO_ORDER_CLASS ? MTO_ORDER_CLASS : 'standard';
  }

  function getCartState(items) {
    const state = { hasMto: false, hasStandard: false };

    items.forEach((item) => {
      if (item.properties?.[MTO_ORDER_CLASS_PROPERTY] === MTO_ORDER_CLASS) {
        state.hasMto = true;
      } else {
        state.hasStandard = true;
      }
    });

    return state;
  }

  function isIncompatible(cart, incomingOrderClass) {
    const state = getCartState(Array.isArray(cart.items) ? cart.items : []);
    if (state.hasMto && state.hasStandard) return true;
    if (incomingOrderClass === MTO_ORDER_CLASS) return state.hasStandard;
    return state.hasMto;
  }

  function showFormError(form, message) {
    const productForm = form.closest('product-form');
    const errorElement = productForm?.querySelector('.js-form-error');
    if (!errorElement) return;

    errorElement.textContent = message;
    errorElement.hidden = false;
    errorElement.setAttribute('tabindex', '-1');
    errorElement.focus({ preventScroll: true });
    window.theme?.scrollToRevealElement?.(errorElement);
  }

  async function validateBeforeAdd(form) {
    const incomingOrderClass = getIncomingOrderClass(form);
    const isMtoContext = form.closest('product-form')?.hasAttribute('data-kuden-mto');

    if (isMtoContext && incomingOrderClass !== MTO_ORDER_CLASS) {
      showFormError(form, MTO_PRODUCT_PAGE_MESSAGE);
      return false;
    }

    const controller = new AbortController();
    const timeoutId = window.setTimeout(() => controller.abort(), CART_CHECK_TIMEOUT_MS);

    try {
      const response = await fetch(getCartJsonUrl(), {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
        signal: controller.signal
      });
      if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);

      const cart = await response.json();
      if (!isIncompatible(cart, incomingOrderClass)) return true;

      showFormError(form, MIXED_CART_MESSAGE);
      return false;
    } catch {
      showFormError(form, CART_CHECK_ERROR_MESSAGE);
      return false;
    } finally {
      window.clearTimeout(timeoutId);
    }
  }

  window.KudenCartCompatibility = Object.freeze({ validateBeforeAdd });
})();
